const detailsViewActionTypes = {
  GET_EXP_DATA: "experiments/GET_EXP_DATA",
  PARSE_EXP_DATA: "experiments/PARSE_EXP_DATA",
  GET_EXP_SCORECARDS: "experiments/GET_EXP_SCORECARDS",
  PARSE_EXP_SCORECARDS: "experiments/PARSE_EXP_SCORECARDS",
  GET_EXP_LOG: "experiments/GET_EXP_LOG",
  PARSE_EXP_LOG: "experiments/PARSE_EXP_LOG",
  GET_EXP_OPS: "experiments/GET_EXP_OPS",
  PARSE_EXP_OPS: "experiments/PARSE_EXP_OPS",
  GET_EXP_ITERS: "experiments/GET_EXP_ITERS",
  PARSE_EXP_ITERS: "experiments/PARSE_EXP_ITERS",
  INIT_START_EXP: "experiments/INIT_START_EXP",
  INIT_ITERATE_EXP: "experiments/INIT_ITERATE_EXP",
  FINISH_START_EXP: "experiments/FINISH_START_EXP",
  FINISH_ITERATE_EXP: "experiments/FINISH_ITERATE_EXP",
  INIT_ADVANCE_EXP: "experiments/INIT_ADVANCE_EXP",
  FINISH_ADVANCE_EXP: "experiments/FINISH_ADVANCE_EXP",
  GET_EXP_ADV_DIFF: "experiments/GET_EXP_ADV_DIFF",
  PARSE_EXP_ADV_EFFECT: "experiments/PARSE_EXP_ADV_EFFECT",
  INIT_STOP_EXP: "experiments/INIT_STOP_EXP",
  FINISH_STOP_EXP: "experiments/FINISH_STOP_EXP",
  INIT_HIDE_EXP: "experiments/INIT_HIDE_EXP",
  FINISH_HIDE_EXP: "experiments/FINISH_HIDE_EXP",
  INIT_UNHIDE_EXP: "experiments/INIT_UNHIDE_EXP",
  FINISH_UNHIDE_EXP: "experiments/FINISH_UNHIDE_EXP",
  INIT_UPDATE_EXP_DETAILS: "experiments/INIT_UPDATE_EXP_DETAILS",
  FINISH_UPDATE_EXP_DETAILS: "experiments/FINISH_UPDATE_EXP_DETAILS",
  SET_EXP_EDIT_VIEW: "experiments/SET_EXP_EDIT_VIEW",
  LOAD_EXP_EDIT_DATA: "experiments/LOAD_EXP_EDIT_DATA",
  LOADING_EXP_EDIT_DATA: "experiments/LOADING_EXP_EDIT_DATA",
  LOADED_EXP_EDIT_DATA: "experiments/LOADED_EXP_EDIT_DATA"
};
export {
  detailsViewActionTypes as default
};
//# sourceMappingURL=DetailsViewActionTypes.js.map
